import TenantsAutocomplete from '@components/Forms/Autocomplete/TenantsAutocomplete';
import { Autocomplete, TextField } from '@mui/material';
import { alpha, Box, useTheme } from '@mui/system';
import { values } from 'lodash';
import React, { FC } from 'react';
import { AnalyticsTimePeriod, IAnalyticsContext } from 'types/analytics';
import { ITheme } from 'types/theme';
import AnalyticsContext from '../analytics/AnalyticsContext';
import { setXDomainAccordingToTimePeriod } from '../analytics/utils';

const AnalyticsHeader: FC = () => {
	const { palette } = useTheme<ITheme>();

	const { setTimePeriod, setTenants, timePeriod, tenants, setXDomain } =
		React.useContext<IAnalyticsContext>(AnalyticsContext);

	const timePeriods = React.useMemo(
		() =>
			values(AnalyticsTimePeriod).map((v) => ({
				id: v as AnalyticsTimePeriod,
				name: intl.tr(`analytics.timePeriod.${v}`)
			})),
		[]
	);

	return (
		<Box
			display="flex"
			flexGrow={1}
			flexDirection="row"
			alignItems="center"
			border={1}
			borderColor="text"
			borderRadius={1}
			p={2}
			sx={{
				backgroundColor: palette.layout.background,
				borderColor: alpha(palette.grey[900], 0.5)
			}}
		>
			<Box width={200}>
				<Autocomplete
					data-testid="analytics-time-period-select"
					value={timePeriods.find((v) => v.id === timePeriod) || timePeriods[0]}
					isOptionEqualToValue={(option, value) => option.id === value.id}
					options={timePeriods || []}
					getOptionLabel={(option) => option.name}
					onChange={(_, v) => {
						const newTimePeriod = v?.id!;
						setTimePeriod(newTimePeriod);
						setXDomain(setXDomainAccordingToTimePeriod(newTimePeriod));
					}}
					clearIcon={null}
					disableCloseOnSelect={false}
					renderInput={(params) => (
						<TextField
							data-testid="analytics-time-period-select-input"
							label={intl.tr('analytics.timePeriod')}
							{...params}
						/>
					)}
				/>
			</Box>
			<Box
				pl={3}
				minWidth={250}
				sx={{
					display: 'none'
				}}
			>
				<TenantsAutocomplete selected={tenants} onChange={setTenants} />
			</Box>
		</Box>
	);
};

export default AnalyticsHeader;
